import { render, staticRenderFns } from "./Intresselijst.vue?vue&type=template&id=73d98bdb&scoped=true&"
import script from "./Intresselijst.vue?vue&type=script&lang=ts&"
export * from "./Intresselijst.vue?vue&type=script&lang=ts&"
import style0 from "./Intresselijst.vue?vue&type=style&index=0&id=73d98bdb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d98bdb",
  null
  
)

export default component.exports